'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { useTheme } from 'styled-components';

const SvgElement = React__default.forwardRef((_a, ref) => {
  var {
      viewBox = '0 0 24 24',
      width = '1em',
      height = '1em',
      fill = 'currentColor'
    } = _a,
    props = __rest(_a, ["viewBox", "width", "height", "fill"]);
  return jsx("svg", Object.assign({
    ref: ref,
    fill: "none",
    height: height,
    viewBox: viewBox,
    width: width,
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: jsx("path", {
      d: "M5 12h14m-7-7v14",
      stroke: fill,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    })
  }));
});
const PlusIcon = _a => {
  var {
      color
    } = _a,
    rest = __rest(_a, ["color"]);
  const theme = useTheme();
  return jsx(SvgElement, Object.assign({
    fill: color && theme.designTokens.colors[color]
  }, rest));
};

export { PlusIcon };
//# sourceMappingURL=PlusIcon.js.map
